/** The ASIS display face. Decorative; live state is always expressed separately in text. */
export function faceMark(mouthId?: string): string {
  return `<svg class="asis-face-mark" viewBox="0 0 240 280" width="60" height="70" aria-hidden="true" focusable="false">
    <rect class="asis-face-background" width="240" height="280" rx="36" fill="var(--night)"/>
    <g class="face-eyes" fill="var(--sky)">
      <rect x="45" y="94" width="50" height="44" rx="16"/><rect x="145" y="94" width="50" height="44" rx="16"/>
    </g>
    <g fill="var(--night)"><rect x="62" y="106" width="16" height="20" rx="8"/><rect x="162" y="106" width="16" height="20" rx="8"/></g>
    <path${mouthId ? ` id="${mouthId}"` : ''} d="M102 184 L138 184" fill="none" stroke="var(--bone)" stroke-width="4" stroke-linecap="round"/>
  </svg>`;
}
